export default {
  CPSRA: 'CPSRA',
  CPSRB: 'CPSRB',
  INFORM: 'INFORM',
};
